import {Observable} from 'rxjs/Observable';

import * as ResourceApi from 'api/resources';
import * as ResourceActions from 'resources/actions';
import * as ProfileActions from './actions';

const saveProfileEpic = (action$) => action$.ofType(ProfileActions.Types.START_SAVE_PROFILE)
    .mergeMap(action => {
      let data = {
        firstName: action.firstName,
        lastName: action.lastName,
        id: action.id,
        email: action.email,
        username: action.username
      };

      const resourceHierarchy = [{type: ResourceApi.Types.AuthenticatedUser, id: action.id}];

      return ResourceApi.saveChangelist(ResourceApi.Types.AuthenticatedUser, action.id, data, resourceHierarchy)
        .map((response) => ProfileActions.saveProfileSuccessAction(response))
        .catch((err, caught) => Observable.of(ProfileActions.saveProfileErrorAction(err.response)));
    });

const fetchProfileEpic = action$ => action$.ofType(ProfileActions.Types.FETCH_USER_PROFILE)
      .mergeMap(action => {
        const profileFetch$ = ResourceApi.getById(ResourceApi.Types.AuthenticatedUser, action.id);

        return profileFetch$
          .map(({response: {object: profile}}) => ProfileActions.receivedUserProfileAction(profile))
          .catch(error => Observable.of({type: 'ERROR', error}));
      });

export default [
  fetchProfileEpic,
  saveProfileEpic
];



// WEBPACK FOOTER //
// ./public/pages/Profile/epics.js